<script setup>
import { ref, watch, computed } from "vue";

const props = defineProps({
    visible: Boolean,
    message: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        default: "info",
        validator: (value) =>
            ["success", "error", "info", "warning", "light"].includes(value),
    },
    timeout: {
        type: Number,
        default: 2500,
    },
});

const emit = defineEmits(["update:visible"]);

const visibleInternal = ref(props.visible);

// Atualiza quando prop externa muda
watch(
    () => props.visible,
    (val) => {
        visibleInternal.value = val;
    },
);

// Emite mudanças para o pai (para controle do v-model:visible)
watch(visibleInternal, (val) => {
    emit("update:visible", val);
});

const colorMap = {
    success: "green",
    error: "red",
    info: "light",
    warning: "orange",
};

const iconMap = {
    success: "mdi-check-circle",
    error: "mdi-alert-circle",
    info: "mdi-information",
    warning: "mdi-alert",
};

// Computed que retorna o ícone certo com base no type
const icon = computed(() => iconMap[props.type] || "mdi-information");
</script>

<template>
    <v-snackbar
        v-model="visibleInternal"
        :timeout="timeout"
        :color="colorMap[type] || 'info'"
        location="top right"
        elevation="24"
    >
        <v-icon class="mr-2">{{ icon }}</v-icon>
        {{ message }}
    </v-snackbar>
</template>
